import React from "react";
import logo from "../assets/images/logo.png";
import iconRetangulo from "../assets/icons/retangulo.svg";
import "../assets/styles/header.scss";
import { Row, Col } from "react-bootstrap";

export default function Header() {
  return (
    <div className="container-header">
      <div className="content-header">
        <Row>
          {/* Coluna principal do texto: Ajustada para ocupar 8/12 avos no LG para dar espaço à imagem */}
          <Col sm={12} lg={8} md={12} xl={9}>
            <div id="brand">
              <img src={logo} alt="Logo Alucom" className="logo" />
            </div>
             <div className="title-container" style={{ marginBottom: "25px" }}>
              <h1 
                className="title" 
                style={{ 
                  fontWeight: "bold",      // Título em Negrito
                  fontSize: "2.5rem",      // Ajuste de tamanho se necessário
                  marginBottom: "5px",
                  color: "#333"            // Cor escura para destacar o Bold
                }}
              >
                Outsourcing de TI
              </h1>
              <div 
                className="title-underline" 
                style={{ 
                  width: "355px",          // Largura da linha vermelha
                  height: "3px",           // Espessura da linha
                  backgroundColor: "#c1272d" 
                }}
              ></div>
            </div>
            <div className="list-equipaments d-flex align-items-start justify-content-start">
              {/* Primeira Lista: 5 itens conforme a foto */}
              <ul className="me-4"> 
                <li>
                  <img src={iconRetangulo} alt="Icone Equipamento" className="p-1" />
                  Computadores e Notebooks
                </li>
                <li>
                  <img src={iconRetangulo} alt="Icone Equipamento" className="p-1" />
                  TV's e Vídeo Wall (4 TVs)
                </li>
                <li>
                  <img src={iconRetangulo} alt="Icone Equipamento" className="p-1" />
                  Roteadores/Switch
                </li>
                <li>
                  <img src={iconRetangulo} alt="Icone Equipamento" className="p-1" />
                  Impressoras/Multifuncionais Laser e Jato de tinta
                </li>
                <li>
                  <img src={iconRetangulo} alt="Icone Equipamento" className="p-1" />
                  Data Show
                </li>
              </ul>

              {/* Segunda Lista: 4 itens conforme a foto */}
              <ul>
                <li>
                  <img src={iconRetangulo} alt="Icone Equipamento" className="p-1" />
                  Plotters
                </li>
                <li>
                  <img src={iconRetangulo} alt="Icone Equipamento" className="p-1" />
                  Tablets
                </li>
                <li>
                  <img src={iconRetangulo} alt="Icone Equipamento" className="p-1" />
                  Impressoras de pulseiras Hospitalares
                </li>
                <li>
                  <img src={iconRetangulo} alt="Icone Equipamento" className="p-1" />
                  Outsourcing de impressão
                </li>
              </ul>
            </div>
          </Col>

          {/* Coluna da Direita (Mantida conforme solicitado) */}
          <Col lg={4} sm={0} md={0} xl={3} className="col-circles">
            <div className="cirles-content">
              <div className="circle-computer"></div>
              <div className="circle-notebook"></div>
              <div className="circle-tablet"></div>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
}
